import React, { useEffect, useMemo, useRef, useState } from 'react';
import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';
import { TransformComponent } from 'react-zoom-pan-pinch';

import classnames from 'classnames';
import { fabric } from 'fabric';

import styles from './styles.module.scss';

const EditingCanvas = ({ editingContext, resetTransform, fastContext }) => {
  const canvasRef = useRef(null);
  const cropping = editingContext.cropping;
  const [crop, setCrop] = useState({});

  const setZoomResetAction = editingContext.zoom.setAction;

  const setCanvas = useMemo(
    () => editingContext.setCanvas,
    [editingContext.setCanvas]
  );

  useEffect(() => {
    if (setZoomResetAction) {
      setZoomResetAction(() => () => resetTransform());
    }
  }, [resetTransform, setZoomResetAction]);

  useEffect(() => {
    if (!canvasRef.current) return;

    const canvasInstance = new fabric.Canvas(canvasRef.current, {
      selection: false,
      selectable: false,
      hoverCursor: 'default'
    });

    setCanvas(canvasInstance);
    if (fastContext.setCanvas) {
      fastContext.setCanvas(canvasInstance);
    }

    return () => {
      canvasInstance.dispose();
      setCanvas(null);
      if (fastContext.setCanvas) {
        fastContext.setCanvas(null);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setCrop(cropping.cropArea);
  }, [cropping.active, cropping.cropArea]);

  return (
    <>
      <div style={{ width: '100%', height: '100%' }}>
        {cropping.active && (
          <ReactCrop
            src={cropping.imageForCropping}
            width={editingContext.canvas.width}
            height={editingContext.canvas.height}
            crop={crop}
            ruleOfThirds
            onChange={setCrop}
            onDragEnd={() => {
              cropping.setCropArea(crop);
            }}
            keepSelection
          />
        )}

        <span
          className={classnames(styles.container, {
            [styles.hidden]: cropping.active && cropping.imageForCropping
          })}
        >
          <TransformComponent wrapperStyle={{ width: '100%', height: '100%' }}>
            <canvas ref={canvasRef} />
          </TransformComponent>
        </span>
      </div>
    </>
  );
};

export default React.memo(EditingCanvas);
